<button
  type="button"
  class="trigger"
  cdkOverlayOrigin
  data-topbar-trigger="user"
  #origin="cdkOverlayOrigin"
  (click)="toggle()"
  [disabled]="!ready()"
  [attr.aria-busy]="!ready() ? true : null"
  [attr.aria-expanded]="open()"
  aria-haspopup="menu"
  data-testid="user-btn"
>
  @if (ready()) {
    <span class="avatar">{{ initials() }}</span>
    <span class="trigger-name">{{ name() }}</span>
  } @else {
    <!-- An empty circle of the right size — never a "?" avatar, which reads
         as a real user whose name we failed to render. -->
    <span class="nbo-skel skel-avatar"></span>
    <span class="nbo-skel skel-name"></span>
  }
  <mat-icon class="chevron" [class.dim]="!ready()">expand_more</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 6 }
  ]"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="onBackdropClick($event)"
  (detach)="onDetach()"
>
  <div class="popover" role="menu" data-testid="user-panel">
    <!-- Name + email only — no invented role subtitle. -->
    <div class="identity">
      <span class="avatar lg">{{ initials() }}</span>
      <span class="identity-text">
        <span class="identity-name">{{ name() }}</span>
        <span class="identity-email">{{ email() }}</span>
      </span>
    </div>

    <div class="divider"></div>

    <!-- Dark mode's first reachable home (closes the NBO-2268 finding).
         Hidden on production until the redesign is complete. -->
    @if (themeSwitchEnabled) {
      <div class="theme-row">
        <span class="theme-label">{{ 'nav.topbar.theme' | translate }}</span>
        <div class="segment" role="group" [attr.aria-label]="'nav.topbar.theme' | translate">
          <button
            type="button"
            class="segment-btn"
            [class.on]="theme() === 'light'"
            [attr.aria-pressed]="theme() === 'light'"
            (click)="setTheme('light')"
            data-testid="theme-light-btn"
          >
            <mat-icon>light_mode</mat-icon>{{ 'nav.topbar.theme_light' | translate }}
          </button>
          <button
            type="button"
            class="segment-btn"
            [class.on]="theme() === 'dark'"
            [attr.aria-pressed]="theme() === 'dark'"
            (click)="setTheme('dark')"
            data-testid="theme-dark-btn"
          >
            <mat-icon>dark_mode</mat-icon>{{ 'nav.topbar.theme_dark' | translate }}
          </button>
        </div>
      </div>
    }

    <a class="row" role="menuitem" [routerLink]="routePaths.Settings" (click)="close()" data-testid="settings-btn">
      <mat-icon class="row-icon">settings</mat-icon>
      <span class="row-label">{{ 'user_menu.settings' | translate }}</span>
    </a>

    <div class="divider"></div>

    <a
      class="row"
      role="menuitem"
      [href]="helpCenterUrl"
      target="_blank"
      rel="noopener noreferrer"
      (click)="close()"
      data-testid="help-center-btn"
    >
      <!-- External links carry the external-link glyph, matching the mockup
           (both Help Center and Developer Docs use it there). -->
      <mat-icon class="row-icon">open_in_new</mat-icon>
      <span class="row-label">{{ 'user_menu.help_center' | translate }}</span>
    </a>

    <a
      class="row"
      role="menuitem"
      [href]="developerDocsUrl"
      target="_blank"
      rel="noopener noreferrer"
      (click)="close()"
      data-testid="developer-docs-btn"
    >
      <mat-icon class="row-icon">open_in_new</mat-icon>
      <span class="row-label">{{ 'user_menu.developer_docs' | translate }}</span>
    </a>

    <div class="divider"></div>

    <button type="button" class="row" role="menuitem" (click)="logout()" data-testid="sign-out-btn">
      <mat-icon class="row-icon">logout</mat-icon>
      <span class="row-label">{{ 'user_menu.sign_out' | translate }}</span>
    </button>
  </div>
</ng-template>
